import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
const _excluded = ["ariaBusy", "ariaLabel", "children", "dataQaData", "dataQaType", "disabled", "flatCorners", "href", "leftIcon", "rightIcon", "inGroup", "isButtonLink", "progressiveFill", "round", "size", "tabIndex", "tagName", "target", "theme", "type", "unselectable", "uppercase", "vertical", "wide", "wideDesktopL", "wideDesktopM", "wideDesktopS", "wideTabletL", "wideTabletS", "onClick", "onMouseLeave", "onMouseOver", "innerRef", "disableHorizontalPadding", "disableVerticalPadding", "UNSAFE_className", "UNSAFE_style"];
import React, { forwardRef } from 'react';
import noop from '@tinkoff/utils/function/noop';
import Clickable from '@platform-ui/clickable';
import useButtonStyle from './useButtonStyles';

// Используется в stories компонентов Button и Group
export const props = {
  sizes: ['l', 'm', 's', 'xs'],
  themes: ['primary', 'primaryOnDark', 'primaryOnLight', 'secondary', 'secondaryOnDark', 'secondaryOnLight', 'secondaryDestructive', 'outline', 'outlineOnDark', 'outlineOnLight', 'accent', 'flat', 'flatOnDark', 'flatOnLight', 'flatDestructive', 'mono']
};
const Button = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      ariaBusy,
      ariaLabel,
      children,
      dataQaData,
      dataQaType,
      disabled,
      href,
      leftIcon,
      rightIcon,
      progressiveFill,
      size,
      tabIndex,
      tagName,
      target,
      type,
      onClick,
      onMouseLeave,
      onMouseOver,
      innerRef,
      UNSAFE_className,
      UNSAFE_style
    } = props,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded);
  const buttonStyles = useButtonStyle(_extends({}, props, {
    UNSAFE_className,
    UNSAFE_style
  }));
  return /*#__PURE__*/React.createElement(Clickable, Object.assign({}, otherProps, {
    "data-size": size,
    ref: ref,
    "aria-busy": ariaBusy,
    dataQaData: dataQaData,
    dataQaType: dataQaType,
    tagName: tagName,
    target: target,
    type: href ? undefined : type,
    href: href,
    "aria-label": (!children || typeof children !== 'string') && ariaLabel || undefined,
    disabled: disabled,
    onClick: onClick,
    onMouseOver: onMouseOver,
    onMouseLeave: onMouseLeave,
    tabIndex: tabIndex,
    className: buttonStyles.button.className,
    style: buttonStyles.button.style,
    innerClassName: buttonStyles.buttonWrapper.className,
    innerRef: innerRef
  }), progressiveFill ? /*#__PURE__*/React.createElement("span", {
    className: buttonStyles.progressiveFillContainer.className
  }, /*#__PURE__*/React.createElement("span", {
    "data-qa-type": `${dataQaType}.progressiveFill`,
    className: buttonStyles.progressiveFill.className,
    style: buttonStyles.progressiveFill.style
  })) : null, leftIcon && /*#__PURE__*/React.createElement("span", {
    className: buttonStyles.icon.className,
    "data-qa-type": `${dataQaType}.icon`
  }, leftIcon), children && /*#__PURE__*/React.createElement("span", {
    className: buttonStyles.content.className,
    "data-qa-type": `${dataQaType}.content`
  }, children), rightIcon && /*#__PURE__*/React.createElement("span", {
    className: buttonStyles.icon.className,
    "data-qa-type": `${dataQaType}.icon`
  }, rightIcon));
});
Button.defaultProps = {
  dataQaType: 'uikit/button',
  size: 'l',
  theme: 'primary',
  type: 'button',
  onClick: noop,
  onMouseOver: noop,
  onMouseLeave: noop
};

// TODO: разобраться как подружить сборку TS и displayName
Button.displayName = 'Button';
export default Button;